export function getServerAddress(ws = false) {
  return `${
    ws ? (window.location.protocol === 'http:' ? 'ws:' : 'wss:') : window.location.protocol
  }//${ process.env.REACT_APP_MOCK_SERVER_ADDRESS || window.location.host }`
}
